import React from "react";
const Renderlpr = ({ item, handleClick }) => {
  // const handleClick = () => {
  //     onClick()
  // }
  return (
    <>
  
        <div className="card  mt-1">
          <div className="row ms-1">
            <div className="col-xs-12 col-sm-4">
              <div
                className=""
                style={{ fontSize: "15px" }}
              >
                <span className="badge rounded-pill bg-secondary">
                  {item.no}
                </span>
              </div>
              <div
                className="mt-1"
                style={{ fontSize: "14px" }}
              >
                {"เวลาล่าสุดที่อ่านได้:"} {item.timerecord}
              </div>

              <div
                className="border-top"
                style={{ fontSize: "14px" }}
              >
                {"ทะเบียน:"}
                {item.drivenno}
              </div>
              <div
                className="border-top"
                style={{ fontSize: "14px" }}
              >
                {"จังหวัด:"} {item.drivenprov}
              </div>
            </div>

            <div className="container col-xs-12 col-sm-4">
              <div
                className="mt-1"
                style={{ fontSize: "14px" }}
              >
                <span style={{ fontSize: "14px" }}>
                  {"ประเภทรถ:"} {item.vehicletype}{" "}
                </span>
              </div>
              <div
                className="border-top"
                style={{ fontSize: "14px" }}
              >
                <span style={{ fontSize: "14px" }}>
                  {"สี: "}
                  <span>{item.color}</span>
                </span>
              </div>

              <div
                className="border-top"
                style={{ fontSize: "14px" }}
              >
                <span style={{ fontSize: "14px" }}>
                  {"สถานะ: "}
                  {item.statusid === 1 ? (
                    <span
                      className="badge bg-success"
                      style={{ fontSize: "14px" }}
                    >
                      {"Online"}
                    </span>
                  ) : (
                    <span
                      className="badge bg-danger"
                      style={{ fontSize: "14px" }}
                    >
                      {"Offline"}
                    </span>
                  )}
                </span>
              </div>
            </div>

            <div className="container col-xs-12 col-sm-4">
              <div
                className="mt-1"
                style={{ fontSize: "14px" }}
              >
                <span style={{ fontSize: "14px" }}>
                  {"รูป:"}
                  <img
                    src={item.imageurl}
                    className="img-fluid img-thumbnail m-2"
                    style={{
                      width: "60px",
                      height: "60px",
                      cursor: "pointer",
                    }}
                    alt="..."
                    onClick={() => handleClick(item.imageurl)}
                  />
                </span>
              </div>

              <div className="d-flex justify-content-end">
                <div></div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default Renderlpr;
